import { StyleSheet, View } from '@react-pdf/renderer';

import { Text } from '../../../components/PdfExportV2/Text/Text.tsx';

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    width: '100%',
    marginBottom: '12px',
  },
  costLine: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  unitCost: {
    marginLeft: '6px',
  },
});

export const ExportCostBreakdownRow = ({
  title,
  value,
  formula,
}: {
  title: string;
  value: string;
  formula: string;
}) => (
  <View style={styles.container}>
    <View style={styles.costLine}>
      <Text variant="h4">{title}</Text>
      <View style={styles.unitCost}>
        <Text variant="body1">{value}</Text>
      </View>
    </View>
    <Text variant="subtitle3">{formula}</Text>
  </View>
);
